<template>

    <div class="clickwrapContainer">
        <iframe :src="`${pdfUrl}#toolbar=0&zoom=110`" title="PDF Viewer" class="tnc" />
        <div class="checkboxClass"> 
            <input name="checkbox" type="checkbox" class="checkbox" id="checkbox" v-model="checkbox">
            <label class="label" for="checkbox">I agree with the Terms and Conditions</label>
            <div @click="onContinueClick" v-bind:class="checkbox ? 'active' : 'inactive' " class="btn">Continue</div>
        </div>
    </div>
</template>

<script>
import router from '../router';
import Header from './Header.vue'
import LeftMenu from './LeftMenu.vue'

import { 
    termsAndConditions,
    getCookie,
    setCookie,
    getQueryParam,
    validateSellerIdAndToken
} from '../services/campaignService';

export default{
    name: 'ClickWrap',
    components: {
        Header,
        LeftMenu
    },
    data(){
        return {
            checkbox: false,
            userId: '',
            role: '',
            pdfUrl: "/tnc.pdf",
        }
    },
    mounted () {
        this.role = getCookie('role');
        if(this.role !== 'SELLER' && this.role !== 'BRAND' && this.role !== 'AGENCY'){
            router.push('/unauthorized');
        }
        this.userId = getCookie('userId');
        validateSellerIdAndToken(this.userId)
        .then(res => res.json())
        .then(data => {
            if (!!data?.token) {
                // authenticated valid case
            } else {
                router.push('/unauthorized');
            }
        })
    },
    methods: {
        isDisabled(){
            return this.checkbox;
        },
        onContinueClick(){
           if(this.checkbox) {
                let params = {
                    "userId": this.userId,
                    "ipAddress": getCookie('ipAddress'),
                    "timestamp": this.getCurrentTimestamp(),
                    "tncAcceptance": this.checkbox
                }
                termsAndConditions(params)
                .then(res=> res.json())
                .then(data => {
                    if(data.code === 200){
                        if(this.role === 'SELLER' || this.role === 'BRAND' || this.role === 'AGENCY'){
                            setCookie('tncAcceptance', data.data?.tncAcceptance) 
                        }
                        this.$router.replace('/campaigns')
                    }
                })
            }
        },
        getCurrentTimestamp() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            
            const timestamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
            return timestamp;
        }

    }
}
</script>

<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }
    .clickwrapContainer{
        font-family: "Inter-Regular";
        background: #F8F8F8;
        text-align: center;
        margin: 0 auto;
        height: 100vh;
    }
    .tnc{
        background: #FFFFFF;
        width: 912px;
        height: 545px;
        margin: 0 auto;
        /* padding: 32px; */
        border-radius: 4px;
        overflow-y: scroll;
    }
    .heading{
        font-family: "Inter-Regular";
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: -0.03em;
        text-align: center;
        color: #141414;
        padding: 32px 32px 16px 32px;
        position: fixed;
        text-align: center;
        width: 812px;
        background: #FFFFFF;
    }
    .content{
        text-align: left;
        overflow-y: scroll;
        padding: 75px 32px 32px 32px;
        color: #1D1D1D;

    }

    .wrapper{
        display: flex;
    }

    .point{
        margin-right: 10px;
        width: 25px;
        text-align: left;
    }

    .checkboxClass{
        max-width: 875px;
        text-align: left;
        margin: 22px auto;
    }

    .label{
        margin-left: 8px;
    }
    .btn{
        width: 214px;
        font-size: 16px;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0em;
        text-align: center;
        color: #FFFFFF;
        border-radius: 4px;
        padding: 13px 0;
        text-align: center;
        background: #2E31BE;
        max-width: 875px;
        margin-top : 26px;
        cursor: pointer;
    }

    .inactive{
        background: #2E31BE;
        opacity: 0.5;
        cursor: not-allowed;
    }
    .container {
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }
    .middlecontainer {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;
    }
</style>
